import { isNumberValidator } from '@/validators';
export const baseFormColumn = (ctx) => {
  return [
    {
      prop: 'contractNo',
      name: '合同号',
      type: 'input',
      disabled: true,
      placeholder: '自动生成',
    },
    {
      prop: 'contractStatus',
      name: '合同状态',
      type: 'select',
      disabled: true,
      options: ctx.contractStatusList,
      placeholder: '自动生成',
    },
    {
      prop: 'parkCompanyName',
      name: '园区公司',
      type: 'input',
      disabled: true,
    },
    {
      prop: 'parkDepartmentName',
      name: '业务部门',
      type: 'input',
      disabled: true,
    },
    {
      prop: 'contractName',
      name: '合同名称',
      type: 'input',
    },
    {
      prop: 'projectName',
      name: '项目名称',
      type: 'searchTableSpec',
      searchType: 'warehouseProject',
      currentValue: ctx.baseFormData.projectName,
      extraData: {
        projectStatus: 'ZT04',
        serviceTypeCode: 'JG',
        applyDepartmentNo: ctx.userInfo.departmentCode,
        bidTitle: ctx.userInfo.companyName,
      },
      isMultiple: true,
      changeMethod: 'changeMethod',
      disabled: ctx.isDisableProjectName,
    },
    {
      prop: 'projectNo',
      name: '项目编号',
      type: 'input',
      disabled: true,
      placeholder: '自动带出',
    },
    {
      prop: 'operatorName',
      name: '操作人',
      type: 'input',
      disabled: true,
      placeholder: '自动填充',
    },
    {
      prop: 'contractType',
      name: '合同类型',
      type: 'select',
      options: ctx.contractTypeList,
      disabled: true, //ctx.isRenewStatus,
    },
    {
      prop: 'signDate',
      name: '签约日期',
      type: 'date',
      // format: 'yyyy-MM-DD',
    },

    {
      prop: 'signPerson',
      name: '签约人',
      type: 'input',
    },
    {
      name: '关联三方租赁合同号',
      prop: 'relatedLeaseContractNo',
      type: 'searchTableSpec',
      searchType: 'leaseContract',
      currentValue: ctx.baseFormData.relatedLeaseContractNo,
      isMultiple: true,
      changeMethod: 'changeMethod',
    },
    {
      prop: 'contractNature',
      name: '合同性质',
      type: 'select',
      options: ctx.contractNatureList,
      disabled: ctx.isProjectToContract || ctx.isRenewStatus,
      changeMethod: 'changeMethod',
    },
    {
      prop: 'contractValidFrom',
      name: '合同有效期起',
      type: 'startDaterangePicker',
      changeMethod: 'changeMethod',
    },
    {
      prop: 'contractValidUntil',
      name: '合同有效期止',
      // type: 'date',
      // format: 'yyyy-MM-DD',
      type: 'endDaterangePicker',
      changeMethod: 'changeMethod',
    },

    {
      prop: 'storageName',
      name: '仓库名称',
      type: 'searchTableSpec',
      searchType: 'warehouse',
      currentValue: ctx.baseFormData.storageName,
      extraData: {
        companyCode: ctx.userInfo.companyCode,
      },
      isMultiple: true,
      changeMethod: 'changeMethod',
    },
    {
      prop: 'storageCompanyName',
      name: '仓库公司',
      type: 'input',
      // searchType: 'warehouseCompany',
      // currentValue: ctx.baseFormData.storageCompanyName,
      // isMultiple: true,
      // changeMethod: 'changeMethod',
      disabled: true,
    },
    {
      prop: 'goodsType',
      name: '货物类型',
      type: 'select',
      options: ctx.goodsTypeList,
      multiple: true,
      changeMethod: 'changeMethod',
    },
    {
      prop: 'goodsCategory',
      name: '货物品类',
      type: 'select',
      placeholder: '请选择货物品类',
      multiple: true,
      options: ctx.goodsCategoryList,
      disabled: ctx.baseFormData.goodsType == '',
      changeMethod: 'changeMethod',
    },
    {
      name: '质权方名称',
      prop: 'pledgeeName',
      type: 'searchTableSpec',
      searchType: 'partner',
      ref: 'pledgeeName',
      currentValue: ctx.baseFormData.pledgeeName,
      extraData: {
        companyCode: ctx.userInfo.companyCode,
      },
      isMultiple: true,
      changeMethod: 'changeMethod',
      disabled: ctx.isRenewStatus,
    },
    {
      prop: 'pledgeeNo',
      name: '质权方编码',
      type: 'input',
      disabled: true,
    },
    {
      prop: 'pledgeeContactPerson',
      name: '质权方联系人',
      type: 'input',
      disabled: ctx.isRenewStatus,
    },
    {
      prop: 'pledgeeContactWay',
      name: '质权方联系方式',
      type: 'input',
      disabled: ctx.isRenewStatus,
    },
    {
      name: '出质方名称',
      prop: 'pledgorName',
      type: 'searchTableSpec',
      searchType: 'partner',
      ref: 'pledgorName',
      currentValue: ctx.baseFormData.pledgorName,
      extraData: {
        companyCode: ctx.userInfo.companyCode,
      },
      isMultiple: true,
      changeMethod: 'changeMethod',
      disabled: ctx.isRenewStatus,
    },
    {
      prop: 'pledgorNo',
      name: '出质方编码',
      type: 'input',
      disabled: true,
    },
    {
      prop: 'pledgorContactPerson',
      name: '出质方联系人',
      type: 'input',
      disabled: ctx.isRenewStatus,
    },
    {
      prop: 'pledgorContactWay',
      name: '出质方联系方式',
      type: 'input',
      disabled: ctx.isRenewStatus,
    },
    {
      name: '关联方名称',
      prop: 'relatedName',
      type: 'searchTableSpec',
      searchType: 'partner',
      currentValue: ctx.baseFormData.relatedName,
      extraData: {
        companyCode: ctx.userInfo.companyCode,
      },
      isMultiple: true,
      changeMethod: 'changeMethod',
      ref: 'relatedName',
      disabled: ctx.isRenewStatus,
      isHidden: ctx.baseFormData.contractNature != 'PIBT12',
    },
    {
      prop: 'relatedNo',
      name: '关联方编码',
      type: 'input',
      disabled: true,
      isHidden: ctx.baseFormData.contractNature != 'PIBT12',
    },
    {
      prop: 'relatedContactPerson',
      name: '关联方联系人',
      type: 'input',
      disabled: ctx.isRenewStatus,
      isHidden: ctx.baseFormData.contractNature != 'PIBT12',
    },
    {
      prop: 'relatedContactWay',
      name: '关联方联系方式',
      type: 'input',
      disabled: ctx.isRenewStatus,
      isHidden: ctx.baseFormData.contractNature != 'PIBT12',
    },
    {
      name: '结算主体',
      prop: 'settlementEntityName',
      type: 'select',
      options: ctx.settlementEntityNameList,
      changeMethod: 'changeMethod',
      placeholder: '请选择结算主体',
      disabled: ctx.isDisabledSettlementEntityName,
    },

    {
      name: '收款方式',
      prop: 'receiveMoneyMethod',
      type: 'select',
      options: ctx.contractPayMethodList,
    },
    {
      name: '合同金额',
      prop: 'contractAmount',
      type: 'inputNumber',
      disabled: true,
      placeholder: '自动生成',
    },
    {
      name: '违约利率',
      prop: 'absentInterestRate',
      type: 'inputNumber',
      append: '%',
    },

    // {
    //   name: '开户行',
    //   prop: 'depositBank',
    //   type: 'searchTableSpec',
    //   searchType: 'bank',
    //   currentValue: ctx.baseFormData.depositBank,
    //   isMultiple: true,
    //   changeMethod: 'changeMethod',
    // },
    // {
    //   name: '银行账号',
    //   prop: 'bankAccount',
    //   type: 'input',
    //   disabled: true,
    // },
    {
      name: '合同数量/重量',
      prop: 'contractQuantity',
      type: 'inputNumber',
    },
    {
      prop: 'paperContractNo',
      name: '纸质合同号',
      type: 'input',
    },
    {
      name: '备注',
      prop: 'remark',
      type: 'input',
    },
  ];
};

// 表单校验
export const baseFormRules = () => {
  return {
    contractName: [{ required: true, message: '合同名称必填', trigger: 'blur' }],
    parkDepartmentName: [{ required: true, message: '园区部门必填', trigger: ['change', 'blur'] }],
    parkCompanyName: [{ required: true, message: '园区公司必填', trigger: ['change', 'blur'] }],
    projectNo: [{ required: true, message: '项目编号必填', trigger: 'blur' }],
    contractType: [{ required: true, message: '合同类型必填', trigger: 'change' }],
    signPerson: [{ required: true, message: '签约人必填', trigger: 'blur' }],
    signDate: [{ required: true, message: '签约日期必填', trigger: 'blur' }],
    contractNature: [{ required: true, message: '合同性质必填', trigger: ['change', 'blur'] }],
    contractValidFrom: [
      { required: true, message: '合同有效期起必填', trigger: ['change', 'blur'] },
      // { validator: validatorContractValidFrom(ctx), trigger: ['blur', 'change'] },
    ],
    contractValidUntil: [
      { required: true, message: '合同有效期止必填', trigger: ['change', 'blur'] },
      // { validator: validatorContractValidUntil(ctx), trigger: ['blur', 'change'] },
    ],
    storageCompanyName: [{ required: true, message: '仓库公司必填', trigger: ['change', 'blur'] }],
    storageName: [{ required: true, message: '仓库名称必填', trigger: ['change', 'blur'] }],
    goodsType: [{ required: true, message: '货物类型必填', trigger: ['blur'] }],
    // goodsCategory: [{ required: true, message: '货物品类必填', trigger: ['change', 'blur'] }],
    pledgeeName: [{ required: true, message: '质权方名称必填', trigger: ['change', 'blur'] }],
    pledgorName: [{ required: true, message: '出质方名称必填', trigger: ['change', 'blur'] }],
    receiveMoneyMethod: [{ required: true, message: '收款方式必填', trigger: ['change', 'blur'] }],
    absentInterestRate: [
      { required: true, message: '违约利率必填', trigger: 'blur' },
      { validator: isNumberValidator, trigger: 'blur' },
    ],
    contractAmount: [
      { required: true, message: '合同金额必填', trigger: ['change', 'blur'] },
      // { validator: isNumberValidator, trigger: 'blur' },
    ],
    depositBank: [{ required: true, message: '开户行必填', trigger: ['change', 'blur'] }],
    bankAccount: [{ required: true, message: '银行账号必填', trigger: 'blur' }],
    // settlementEntityName: [{ required: true, message: '结算主体必填', trigger: ['blur'] }],
    projectName: [{ required: true, message: '项目名称必填', trigger: ['change', 'blur'] }],
  };
};

// const validatorContractValidFrom = (ctx) => {
//   return (_, value, callback) => {
//     if (value) {
//       if (ctx.baseFormData.contractValidUntil && value > ctx.baseFormData.contractValidUntil) {
//         callback(new Error('合同有效期起必须小于合同有效期止!'));
//       }
//       return callback();
//     } else {
//       return callback();
//     }
//   };
// };
// const validatorContractValidUntil = (ctx) => {
//   return (_, value, callback) => {
//     if (value) {
//       if (ctx.baseFormData.contractValidFrom && value < ctx.baseFormData.contractValidFrom) {
//         callback(new Error('合同有效期止必须大于合同有效期起!'));
//       }
//       return callback();
//     } else {
//       return callback();
//     }
//   };
// };
